// extracted by mini-css-extract-plugin
module.exports = {"modal":"need-sign-in-modal_modal__bQLdH","main_text":"need-sign-in-modal_main_text__yvM7O","info_container":"need-sign-in-modal_info_container__HgKE2"};